import axios from "../utiles/axios.util";

function apiGetStatus() {
    return axios.get(`/api/v1/auth/status`);
}

function apiPostlogin(formData) {
    return axios.post("/api/v1/auth/login", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

function apiGetLogout() {
    return axios.get(`/api/v1/auth/logout`);
}

export { apiGetStatus, apiPostlogin, apiGetLogout };
